import { LOGIN_CHANGE } from 'actions';
import { connect } from 'react-redux';
import Login from './component';

const mapStateToProps = ({ ui }) => ({
  form: ui.login.form,
});

const mapDispatchToProps = (dispatch) => ({
  mountLogin: () =>
    dispatch(
      LOGIN_CHANGE({
        form: 'login',
        flow: 'login',
        delivery: {},
        user: {},
      }),
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
